import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import InitialInvestment from "./pages/InitialInvestment";
import ExecutiveSummary from "./pages/ExecutiveSummary";
import Transactions from "./pages/Transactions";
import Cars from "./pages/Cars";
import CarDetail from "./pages/CarDetail";
import CategoriesSuppliers from "./pages/CategoriesSuppliers";
import Insurance from "./pages/Insurance";
import Expirations from "./pages/Expirations";
import Projection from "./pages/Projection";
import Reminders from "./pages/Reminders";
import ImportPage from "./pages/Import";
import DriverHistory from "./pages/DriverHistory";
import Login from "./pages/Login";
import PublicChecklist from "./pages/PublicChecklist";
import Users from "./pages/Users";
import { AuthProvider, useAuth } from "./lib/auth";

function ProtectedRoute({ children, adminOnly = false, blockViewer = false }) {
    const { status, user } = useAuth();
    const location = useLocation();
    if (status === "checking") {
        return <div className="min-h-screen grid place-items-center text-slate-400 text-sm">Cargando…</div>;
    }
    if (status !== "authed") {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    if (adminOnly && user?.role !== "admin") {
        return <Navigate to="/" replace />;
    }
    if (blockViewer && user?.role === "lector") {
        return <Navigate to="/" replace />;
    }
    return children;
}

function App() {
    return (
        <div className="App">
            <Toaster position="top-right" richColors />
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/revision-conductor" element={<PublicChecklist />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/inversion-inicial" element={<InitialInvestment />} />
                            <Route path="/resumen-ejecutivo" element={<ExecutiveSummary />} />
                            <Route index element={<Dashboard />} />
                            <Route path="/transacciones" element={<Transactions />} />
                            <Route path="/autos" element={<Cars />} />
                            <Route path="/autos/:carId" element={<CarDetail />} />
                            <Route path="/catalogos" element={<CategoriesSuppliers />} />
                            <Route path="/seguros" element={<Insurance />} />
                            <Route path="/vencimientos" element={<Expirations />} />
                            <Route path="/proyeccion" element={<Projection />} />
                            <Route path="/recordatorios" element={<Reminders />} />
                            <Route path="/historial-conductores" element={<DriverHistory />} />
                            <Route
                                path="/importar"
                                element={
                                    <ProtectedRoute blockViewer>
                                        <ImportPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/usuarios"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <Users />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
